import { stringify } from 'query-string';
import { apiUrl } from './services/env';
import request, { fetcher, suspenseFetcher } from './services/request';

function createSubmission(pageId, data) {
  return request(`${apiUrl}/checkout/${pageId}/submissions`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });
}

function createPayment(pageId, data) {
  return request(`${apiUrl}/checkout/${pageId}/charges`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });
}

function createSubscription(data) {
  return request(`${apiUrl}/subscriptions`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });
}

function processSubscription(data, id) {
  return request(`${apiUrl}/subscriptions/${id}/process`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });
}

function getChargeByClientSecret(clientSecret) {
  return request(`${apiUrl}/charges/client-secret/${clientSecret}`);
}

function validateCoupon(body, pageId, sellerId) {
  return request(`${apiUrl}/checkout/sellers/${sellerId}/pages/${pageId}/validate-coupon`, null, {
    body: JSON.stringify(body),
    method: 'POST',
  });
}

function getCouponByStripeCouponId(stripeCouponId, sellerId) {
  return request(
    `${apiUrl}/checkout/sellers/${sellerId}/get-coupon-by-stripe-coupon-id/${stripeCouponId}`,
    null,
    {
      method: 'GET',
    },
  );
}

function getPaymentStatus(id, sessionId) {
  return request(`${apiUrl}/checkout/payments/${id}/status?${stringify({ sessionId })}`);
}

function getSubscriptionStatus(id, sessionId) {
  return request(`${apiUrl}/checkout/subscriptions/${id}/status?${stringify({ sessionId })}`);
}

function getCheckout(sellerId, pageId, params = {}, token) {
  return suspenseFetcher(
    `/checkout/sellers/${sellerId}/pages/${pageId}?${stringify(params)}`,
    token,
  );
}

function calculateTax(body, sellerId, pageId) {
  return fetcher(`/checkout/sellers/${sellerId}/pages/${pageId}/calculate-tax`, null, {
    body: JSON.stringify(body),
    method: 'POST',
  });
}

export async function calculateProration(body, sellerId, pageId) {
  return fetcher(`/checkout/sellers/${sellerId}/pages/${pageId}/calculate-proration`, null, {
    body: JSON.stringify(body),
    method: 'POST',
  });
}

function getOrder(orderId, sessionId) {
  return fetcher(`/checkout/orders/${orderId}?${stringify({ sessionId })}`);
}

function getSubmission(submissionId, sessionId) {
  return fetcher(`/checkout/submissions/${submissionId}?${stringify({ sessionId })}`);
}

function getCharge(paymentId, sessionId) {
  return fetcher(`/checkout/payments/${paymentId}?${stringify({ sessionId })}`);
}

function getSubscription(paymentId, sessionId) {
  return fetcher(`/checkout/subscriptions/${paymentId}?${stringify({ sessionId })}`);
}

function getCountryCode() {
  return fetcher(`/checkout/country-code`);
}

function setPaymentError(paymentError, id) {
  return request(`${apiUrl}/charges/${id}/error`, null, {
    body: JSON.stringify({ paymentError }),
    method: 'POST',
  });
}

function setSubscriptionError(paymentError, id) {
  return request(`${apiUrl}/subscriptions/${id}/error`, null, {
    body: JSON.stringify({ paymentError }),
    method: 'POST',
  });
}

function getTemplateByPageId(pageId) {
  return fetcher(`/checkout/template-by-page-id/${pageId}`);
}

function createOrUpdateCheckoutEvent(pageId, data, checkoutEventId) {
  return request(`${apiUrl}/checkout/${pageId}/checkout-event?checkoutEventId=${checkoutEventId}`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });
}

function getCheckoutEventById(pageId, checkoutEventId) {
  return fetcher(`/checkout/${pageId}/checkout-event?checkoutEventId=${checkoutEventId}`);
}

export default {
  getCheckout,
  createSubmission,
  createPayment,
  createSubscription,
  processSubscription,
  getChargeByClientSecret,
  validateCoupon,
  getCouponByStripeCouponId,
  getPaymentStatus,
  getSubscriptionStatus,
  setPaymentError,
  setSubscriptionError,
  getSubmission,
  getOrder,
  getCharge,
  getSubscription,
  getCountryCode,
  calculateTax,
  getTemplateByPageId,
  calculateProration,
  createOrUpdateCheckoutEvent,
  getCheckoutEventById,
};
